import jQuery from 'jquery'

jQuery(document).ready(function ($) {
  const $eventSchedule = $('.dhsv_vc_event_schedule')

  if ($eventSchedule.length === 0) {
    return
  }

  $eventSchedule.each(function () {
    const $container = $(this)
    const $tabs = $container.find('.dhsv_vc_event_schedule__tab')
    const $columns = $container.find('.dhsv_vc_event_schedule__column')

    // Handle tab clicks
    $tabs.on('click', function () {
      const $clickedTab = $(this)
      const tabIndex = parseInt($clickedTab.data('tab-index'), 10)

      // Remove active class from all tabs and columns
      $tabs.removeClass('dhsv_vc_event_schedule__tab--active')
      $columns.removeClass('dhsv_vc_event_schedule__column--active')

      // Add active class to clicked tab and corresponding column
      $clickedTab.addClass('dhsv_vc_event_schedule__tab--active')
      $columns
        .filter(`[data-column-index="${tabIndex}"]`)
        .addClass('dhsv_vc_event_schedule__column--active')
    })
  })
})
